<template>
  <div class="modal is-active">
    <div class="modal-background" @click="CloseModal()"></div>

    <div class="modal-content slide-down">
      <div class="box">
        <div class="box-header">
          <h3>Reason for rejected</h3>
        </div>
        <div class="field">
          <div class="control">
            <textarea
              class="textarea"
              v-model="reason"
              placeholder=""
            ></textarea>
          </div>
        </div>
        <div class="button-group">
          <button @click="changeStatus()" class="button primary">
            Sumit
          </button>
        </div>
      </div>
    </div>

    <button
      @click="CloseModal()"
      class="modal-close is-large"
      aria-label="close"
    ></button>
  </div>
</template>
<script>
import { apolloClient } from "../../services/apollo-client";
import { CHANGE_SEEKER_STATUS } from "../../graphql/seeker/seeker";
export default {
  data: () => ({
    reason: "",
  }),
  methods: {
    CloseModal() {
      this.$emit("CloseModal", false);
    },
    async changeStatus() {
      await apolloClient.mutate({
        mutation: CHANGE_SEEKER_STATUS,
        variables: {
          seekerId: this.$route.params.id,
          status: "Rejected",
          reason: this.reason,
        },
      });
      this.$router.push({
        name: "approved-jobseeker",
        query: {
          type: "Rejected",
          p: 10,
          q: 1,
          s: "",
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.error_text {
  color: red;
}
.modal {
  z-index: 999;
  .modal-background {
    background-color: rgba(var(--dark-grey-color), 0.3);
    backdrop-filter: blur(5px);
  }
  .modal-content {
    z-index: 999;
    max-width: 450px;
    overflow-y: auto;
    .box {
      padding: 30px;
      //border-radius: $radius;
      animation: fade 0.3s;
      background-color: #fff;
      box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.5);
      @keyframes fade {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
      .box-header {
        h3 {
          font-size: var(--xlg-font);
          font-weight: 700;
          text-transform: uppercase;
          color: var(--primary-color);
        }
      }
      .form {
        margin: 20px 0 30px;
        .field {
          margin-bottom: 20px;
          .label {
            margin-bottom: 5px;
            font-size: var(--md-font);
          }
          a {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            margin-top: 10px;
            color: var(--alert-color);
            font-size: var(--sm-font);
          }
        }
      }
      p {
        width: 100%;
        justify-content: center;
        display: flex;
        text-align: center;
        font-size: var(--md-font);
        a {
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
